import { render, staticRenderFns } from "./HeroItem.vue?vue&type=template&id=5f075799"
import script from "./HeroItem.vue?vue&type=script&lang=js"
export * from "./HeroItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports